<template>
  <div class="plat-student-account-info">
    <StudentLoginPanel ref="panel"
                       v-bind="$attrs"
                       v-on="$listeners"
                       @start-refresh="startRefresh"
                       @end-refresh="endRefresh"></StudentLoginPanel>
  </div>
</template>

<script>
import StudentLoginPanel from '../../../../../../wrapper/panel/student/login'
import Dashboard from '../../../../../../../../../../mixins/custom/dashboard'
export default {
  name: 'PlatStudentAccountInfo',
  mixins: [Dashboard],
  components: {
    StudentLoginPanel
  },
  methods: {
    handleRefresh () {
      if (this.isCurrent) {
        const panel = this.$refs.panel
        if (panel) {
          panel.loadLoginInfo()
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .plat-student-account-info {
    height: 100%;
  }
</style>
